
const Preloader = () => {
  return (
    <div className="preloader"> 
        <figure>
            <img src="/logo.png" alt="logo" /> 
        </figure>
    </div>
  );
};
export default Preloader;
